import { render, staticRenderFns } from "./CommissionRuleEdit.vue?vue&type=template&id=fcf4ac32&"
import script from "./CommissionRuleEdit.vue?vue&type=script&lang=ts&"
export * from "./CommissionRuleEdit.vue?vue&type=script&lang=ts&"
import style0 from "./CommissionRuleEdit.vue?vue&type=style&index=0&id=fcf4ac32&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports